import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import { useTheme } from 'styled-components';
import GTM_HANDLES from '#/shared/gtm-handles';
import * as Styled from './styled';

function EditButton({
  Icon,
  onClick,
  buttonAriaLabelIntlId,
  iconAriaLabelIntlId,
  className,
}) {
  const intl = useIntl();

  return (
    <Styled.EditButton
      onClick={onClick}
      type="button"
      aria-label={
        buttonAriaLabelIntlId &&
        intl.formatMessage({ id: buttonAriaLabelIntlId })
      }
      className={className}
      data-gtm={GTM_HANDLES.dateTimeSettings.editButton}
    >
      <FormattedMessage id="planner.edit" />
      <Styled.EditIconWrapper>
        <Icon
          role="img"
          aria-label={
            iconAriaLabelIntlId &&
            intl.formatMessage({ id: iconAriaLabelIntlId })
          }
        />
      </Styled.EditIconWrapper>
    </Styled.EditButton>
  );
}

EditButton.propTypes = {
  /** Icon component that will appear inside the button */
  Icon: PropTypes.elementType.isRequired,
  /** Handler for components click event */
  onClick: PropTypes.func,
  /** ID used to fetch localized text for button aria label */
  buttonAriaLabelIntlId: PropTypes.string,
  /** ID used to fetch localized text for icon aria label */
  iconAriaLabelIntlId: PropTypes.string,
  /** Pass-through to allow styling via styled-components */
  className: PropTypes.string,
};

EditButton.defaultProps = {
  onClick: () => {},
  buttonAriaLabelIntlId: undefined,
  iconAriaLabelIntlId: undefined,
  className: null,
};

function CloseButton({ onClick }) {
  const theme = useTheme();

  /** TODO: Remove 'legacy' check when ready to sunset legacy
   * https://trimet.atlassian.net/browse/PRJ77-569
   */
  return (
    <Styled.CloseButton
      onClick={onClick}
      variant={theme.name === 'Legacy' ? 'outline-reverse' : 'outline'}
      type="button"
    >
      <FormattedMessage id="planner.close" />
    </Styled.CloseButton>
  );
}

CloseButton.propTypes = {
  /** Handler for button's click event */
  onClick: PropTypes.func,
};

CloseButton.defaultProps = {
  onClick: () => {},
};

export { EditButton, CloseButton };
